
import { IIdsRequest } from "../../../models/request/base/IIdsRequest";
import { IDotDanhGiaLop } from "../../../models/response/danh-gia/IDotDanhGiaLop";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export interface IDotDanhGiaLopActionTypeBase<T> {
    dotDanhGiaId: number,
    data: T
}
export const eDotDanhGiaLopActionTypeDefine = {
    CHANGE_DOT_DANH_GIA_SELECTED_ID: {} as IDotDanhGiaLopActionTypeBase<undefined>,
    CHANGE_SELECTED_IDS: {} as IDotDanhGiaLopActionTypeBase<number[]>,

    LOAD_START: {} as IDotDanhGiaLopActionTypeBase<undefined>,
    LOAD_SUCCESS: {} as IDotDanhGiaLopActionTypeBase<IDotDanhGiaLop[]>,
    LOAD_ERROR: {} as IDotDanhGiaLopActionTypeBase<string>,

    SHOW_ADD_LOP_MODAL: {} as IDotDanhGiaLopActionTypeBase<boolean>,

    ADD_LOP_START: {} as IDotDanhGiaLopActionTypeBase<IDotDanhGiaLop[]>,
    ADD_LOP_SUCCESS: {} as IDotDanhGiaLopActionTypeBase<IDotDanhGiaLop[]>,
    ADD_LOP_ERROR: {} as IDotDanhGiaLopActionTypeBase<string>,

    UPDATE_LOP_START: {} as IDotDanhGiaLopActionTypeBase<IDotDanhGiaLop[]>,
    UPDATE_LOP_SUCCESS: {} as IDotDanhGiaLopActionTypeBase<IDotDanhGiaLop[]>,
    UPDATE_LOP_ERROR: {} as IDotDanhGiaLopActionTypeBase<string>,

    DELETE_LOP_START: {} as IDotDanhGiaLopActionTypeBase<IIdsRequest>,
    DELETE_LOP_SUCCESS: {} as IDotDanhGiaLopActionTypeBase<number[]>,
    DELETE_LOP_ERROR: {} as IDotDanhGiaLopActionTypeBase<string>,

}
export const eDotDanhGiaLopActionTypeIds = generateActionTypeIds(eDotDanhGiaLopActionTypeDefine, "DOT_DANH_GIA_LOP")

export type IDotDanhGiaLopActionType = IGenericActionType<typeof eDotDanhGiaLopActionTypeDefine, "DOT_DANH_GIA_LOP">